import React from 'react'
import {Field} from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import {Checkbox} from "components/Form/SpecialButtons";

const GeneralForm = ({ element }) => (

    <div>
        <Field type="text" name="label" customlabel="Libellé du code Question" component={CustomInputTextComponent} required/>
        <Field type="text" name="code" customlabel="Code Question" component={CustomInputTextComponent} required/>
        <Field type="text" name="sil_code" customlabel="Code SIL" component={CustomInputTextComponent} required/>
        <Field type="text" name="code_comment" customlabel="Commentaire" component={CustomInputTextComponent}/>
        <Field type="text" name="group" customlabel="Regroupement" component={CustomInputTextComponent}/>
        <Field customlabel="Question uniquement pour préleveur" component={Checkbox} name="target" id="target"  />

    </div>


)

export default GeneralForm